import api, { METHODS } from './api'

export default async function getKeepRequestJsonAfterProcessFlag(): Promise<boolean> {
    try {
        const keepRequestJsonAfterProcessFlag = await api<{keepRequestJsonAfterProcessFlag: boolean}>(
            `keepRequestJsonAfterProcessFlag`, // for apache servers
            METHODS.GET
        )

        return keepRequestJsonAfterProcessFlag.keepRequestJsonAfterProcessFlag
    } catch (error) {
        // TODO: use logger
        // console.error(error)
        console.error("Could not get the current set flag to keep the request json for the screenshot generated in the report's process", error)
        
        return false
    }
}